export { navigate } from './lib/navigation';

export { default as CTA } from './ui/CTA/CTA';
export { default as CourseModules } from './ui/CourseModules/CourseModules';
export { default as HowItWorks } from './ui/HowItWorks/HowItWorks';
export { default as PartnershipInfo } from './ui/PartnershipInfo/PartnershipInfo';
export { default as Plans } from './ui/Plans/Plans';
export { default as QEDUPlatform } from './ui/QEDUPlatform/QEDUPlatform';
export { default as VideoCard } from './ui/VideoCard/VideoCard';
export { default as WhoIsItFor } from './ui/WhoIsItFor/WhoIsItFor';
